module.exports = __webpack_public_path__ + "img/cs.a71e4d51.png";